// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__-vOlW","searchInput":"SearchBar_searchInput__Ql+wC"};